import React from "react";
import useSWR from "swr";
import { Box, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import HelloText from "../components/HelloText";
const Form = () => {
  let params = useParams();
  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "form?id=" + params.formId
  );

  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <div>
      <HelloText />
      <Box 
      sx={{
        "& > :not(style)": {
          m: 1,
          width: "80%",
          display: "flex",
          alignItems: "center",
        },
      }}>
      <TextField
        id="outlined-basic"
        label="İsim"
        variant={"outlined"}
        fullWidth
        disabled
        defaultValue={data.name}
      />
       <TextField
        id="outlined-basic"
        label="Mail"
        variant={"outlined"}
        fullWidth
        disabled
        defaultValue={data.mail}
      />
       <TextField
        id="outlined-basic"
        label="Numara"
        variant={"outlined"}
        fullWidth
        disabled
        defaultValue={data.phone}
      />
       <TextField
        id="outlined-basic"
        label="Konu"
        variant={"outlined"}
        fullWidth
        disabled
        defaultValue={data.title}
      />
       <TextField
        id="outlined-basic"
        label="Mesaj"
        variant={"outlined"}
        fullWidth
        disabled
        multiline
        defaultValue={data.text}
      />
      </Box>
    </div>
  );
};

export default Form;
